<template>
  <div>
    <template v-for="priority in priorities">
      <priority-item
        v-if="edit!==priority.id"
        :key="priority.id"
        :priority="priority"
        :editable="editable"
        :deletable="deletable"
        @toggle="$emit('toggle', $event)"
        @delete="$emit('delete', $event)"
        @edit="onStartEdit"
      />
      <div v-else :key="priority.id">
        <slot name="update" v-bind="{ priority, close: closeUpdate }" />
      </div>
    </template>
    <div v-if="canAdd" class="mt-3 ml-2">
      <div v-if="showNew">
        <slot name="add" v-bind="{ close: closeAdd }" />
      </div>
      <b-link v-else variant="link" @click.prevent="onStartAdd">
        <b-icon-plus-circle-fill font-scale="1.5" />
        <span class="pl-3">Add item</span>
      </b-link>
    </div>
  </div>
</template>

<script>
import PriorityItem from './PriorityItem'

export default {
  name: 'PrioritiesList',

  props: {
    priorities: {
      type: Array,
      default: () => ([])
    },

    editable: {
      type: Boolean,
      default: false
    },

    deletable: {
      type: Boolean,
      default: false
    },

    canAdd: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      edit: null,
      showNew: false
    }
  },

  methods: {
    onStartAdd() {
      this.showNew = true
      this.edit = null
    },

    onStartEdit({ id }) {
      this.showNew = false
      this.edit = id
    },

    closeUpdate() {
      this.edit = null
    },

    closeAdd() {
      this.showNew = false
    }
  },

  components: {
    PriorityItem
  }
}
</script>
